// extracted by mini-css-extract-plugin
module.exports = {"chevron-container":"AccordionButton_chevron-container__XjZ72","chevron-container__opened":"AccordionButton_chevron-container__opened__gFITQ"};